import React from 'react';

const CaretLargeDownIcon: React.FC = () => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M6.53906 9.28906C6.23438 9.57031 5.76562 9.57031 5.46094 9.28906L1.71094 5.53906C1.5 5.30469 1.42969 5 1.54688 4.71875C1.66406 4.4375 1.94531 4.25 2.25 4.25H9.75C10.0547 4.25 10.3359 4.4375 10.4531 4.71875C10.5703 5 10.5 5.32812 10.2891 5.53906L6.53906 9.28906Z" />
    </svg>
);

export default CaretLargeDownIcon;
